import { render, staticRenderFns } from "./AddAgent.component.vue?vue&type=template&id=6c2a32ae&"
import script from "./AddAgent.component.vue?vue&type=script&lang=ts&"
export * from "./AddAgent.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports